<template>
  <v-slide-group v-model="slide" show-arrows>
    <v-slide-item
      v-for="(item, i) in sorted_core_values"
      class="my-4 mx-3"
      :key="i"
    >
      <v-badge color="secondarytext" :content="badgeContent(item)" overlap>
        <avatar
          :badgeUrl="item.badgeUrl"
          :fill="$vuetify.theme.themes.light.secondarytext"
          :size="size"
        >
          <template v-slot:tooltip>
            {{ item.name }}
          </template>
        </avatar>
      </v-badge>
    </v-slide-item>
  </v-slide-group>
</template>

<script>
export default {
  name: "RecognitionBadges",
  props: { coreValues: { type: Array }, size: { type: Number, default: 55 } },
  data: () => ({
    slide: null
  }),
  computed: {
    sorted_core_values() {
      return this._.orderBy(this.coreValues, ["value"], ["desc"]);
    },
    badgeContent() {
      return cv => {
        let value = Math.round(cv.value);
        if (value == 0) {
          return "0";
        }
        return `${value}x`;
      };
    }
  }
};
</script>
